import { render, staticRenderFns } from "./ResumeEntity.vue?vue&type=template&id=21b0bc4a&"
import script from "./ResumeEntity.vue?vue&type=script&lang=js&"
export * from "./ResumeEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports